import { FacetSource } from "./buildSources";
import { match } from "ts-pattern";

export type TagItem = {
  label: string;
  originalSource: FacetSource;
  originalLabel: string;
};

export const tagItem = (source: FacetSource, label: string): TagItem => ({
  originalSource: source,
  label: facetLabel(source, label),
  originalLabel: label
});

export const facetLabel = (source: FacetSource, label: string) =>
  match(source)
    .when(
      (source) => source.includes("cruiseTagsTree"),
      () => label.split(" > ")[1] ?? label
    )
    .otherwise(() => label);
